"use strict";

// We override loadPage & loadPagesync to fix canonical redirects
// we also override hovering to disable hover prefetch
exports.onClientEntry = function () {
  var loader = window.___loader; // if development or no loader exists we shouldn't do anything

  if (process.env.NODE_ENV === 'development' || !loader) {
    return;
  }

  var pagePath = window.pagePath;
  var location = window.location;

  var parsePathComponents = function parsePathComponents(pathAndQuery) {
    var queryIndex = pathAndQuery.indexOf('?');
    var path = queryIndex > -1 ? pathAndQuery.substr(0, queryIndex) : pathAndQuery;
    var query = queryIndex > -1 ? pathAndQuery.substr(queryIndex) : '';
    return {
      path: path,
      query: query
    };
  };

  if (pagePath && pagePath !== location.pathname && pagePath !== location.pathname + '/') {
    var originalLoadPageSync = loader.loadPageSync;
    var originalLoadPage = loader.loadPage;

    loader.loadPageSync = function (path) {
      // with Gatsby v4, 'path' can now be a path component, or path component + query
      var _parsePathComponents = parsePathComponents(path),
          pathComponent = _parsePathComponents.path,
          queryComponent = _parsePathComponents.query;

      var pageResources; // if the path is the same as our current page we know it's not a prefetch

      if (pathComponent === location.pathname) {
        pageResources = originalLoadPageSync(pagePath + queryComponent);
      } else {
        pageResources = originalLoadPageSync(path);
      }

      if (pageResources.page) {
        pageResources.page.matchPath = '*';
      }

      return pageResources;
    };

    loader.loadPage = function (path) {
      // with Gatsby v4, 'path' can now be a path component, or path component + query
      var _parsePathComponents2 = parsePathComponents(path),
          pathComponent = _parsePathComponents2.path,
          queryComponent = _parsePathComponents2.query;

      var pageResources; // if the path is the same as our current page we know it's not a prefetch

      if (pathComponent === location.pathname) {
        pageResources = originalLoadPage(pagePath + queryComponent);
      } else {
        pageResources = originalLoadPage(path);
      }

      if (pageResources.page) {
        pageResources.page.matchPath = '*';
      }

      return pageResources;
    };
  } // disable hovering prefetching as we don't know if we can.


  loader.hovering = function () {};
}; // we also need to disable prefetching as we don't know the exact page-data path.
// TODO look at prefetch a whole html page on hover?


exports.disableCorePrefetching = function () {
  return true;
};